import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6307f280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reactive-width backdrop" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-wrapper" }, [
  /*#__PURE__*/_createTextVNode(" Pick the place you prefer until there's only one left. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ( Or pick the place you hate least. ) ")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "tournament-view"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "super-center" }, "or", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptionButton = _resolveComponent("OptionButton")!
  const _component_OptionAddress = _resolveComponent("OptionAddress")!
  const _component_OptionRatings = _resolveComponent("OptionRatings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.option1 in _ctx.places1 && _ctx.option2 in _ctx.places1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_OptionButton, {
            label: _ctx.places1[_ctx.option1].Name,
            clickEvent: _ctx.updateList,
            first: true
          }, null, 8, ["label", "clickEvent"]),
          _hoisted_4,
          _createVNode(_component_OptionButton, {
            label: _ctx.places1[_ctx.option2].Name,
            clickEvent: _ctx.updateList,
            first: false
          }, null, 8, ["label", "clickEvent"]),
          _createVNode(_component_OptionAddress, {
            address: _ctx.places1[_ctx.option1].Vicinity
          }, null, 8, ["address"]),
          _hoisted_5,
          _createVNode(_component_OptionAddress, {
            address: _ctx.places1[_ctx.option2].Vicinity
          }, null, 8, ["address"]),
          _createVNode(_component_OptionRatings, {
            rating: _ctx.places1[_ctx.option1].Rating,
            amount: _ctx.places1[_ctx.option1].TotalRatings
          }, null, 8, ["rating", "amount"]),
          _hoisted_6,
          _createVNode(_component_OptionRatings, {
            rating: _ctx.places1[_ctx.option2].Rating,
            amount: _ctx.places1[_ctx.option2].TotalRatings
          }, null, 8, ["rating", "amount"])
        ]))
      : _createCommentVNode("", true)
  ]))
}